import apiPaths from '../api-paths.js';

export default {
  index(query = '') {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices${ query }`);
  },
  indexAutomatic(query = '') {
    return axios.post(`${ apiPaths.BOOKKEEPING }/invoices/by-period/KLA${ query }`);
  },
  indexByNoPaid(query = '') {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices/by-not-paid${ query }`);
  },
  show(id) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/invoices/${ id }`);
  },
  showForDuplicate(id) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/invoices/${ id }/for-duplicate`);
  },
  store(invoice) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/invoices`, { invoice });
  },
  update(invoice) {
    return axios.put(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices/${ invoice.id }`, { invoice });
  },
  calculate(invoice) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/invoices/calculate`, { invoice });
  },
  validate({ invoice, signal = undefined }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/invoices/validate`, { invoice }, { signal });
  },
  getSummaryByPeriod({ period }) {
    return axios.post(import.meta.env.VITE_SITE_URL + `/bookkeepings/invoices/summary/by-period`, { period });
  },
  exportToOptima({ exportRequest }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/invoices/export/optima`, exportRequest);
  },
};
